<template>
    <div class="agent_list_style batch_btn" :style="screenHeight">
        <div class="fixed_search" style="height: 100px;">
          <div class="fixed_search_input">
            <Input v-model="agentNumber" placeholder="请输入访客经理" title="访客经理"  clearable/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="leaveName" placeholder="请输入访客名称" title="访客名称"  clearable/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="leavePhone" placeholder="请输入访客号码" title="访客号码"  clearable/>
          </div>

          <div class="fixed_search_input">
            <Select v-model="leaveChannel" placeholder="请选择留言渠道" title="留言渠道" clearable>
              <Option v-for="(option, index) in messageChannelList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
           <div class="fixed_search_input">
            <Input v-model="leaveContent" placeholder="请输入留言内容" title="留言内容"  clearable/>
          </div>
          <div class="fixed_search_input">
            <Select v-model="agentNumberAssign" placeholder="请选择分配状态" title="分配状态" clearable>
              <Option v-for="(option, index) in messageStatusList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="fixed_search_input">
            <Select v-model="isCallBack" placeholder="请选择回访状态" title="回访状态" clearable>
              <Option v-for="(option, index) in messageResultList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="date_input fixed_search_input">
            <el-date-picker v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
          <div class="fixed_operation_btn">
            <Button type="primary" @click="initSearch">查询</Button>
           <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>

          </div>
        </div>
        <div class="public_btn" >
          <Button  class="search_btn template_btn"  @click="batchOperation('8_2-10-1','导出')" v-if="roleList['8_2-10-1']">导出</Button>
          <Button  class="search_btn template_btn"  @click="distribution" v-if="roleList['8_2-10-2']">分配</Button>
          <Button  class="search_btn template_btn"  @click="dealLocation('8_2-10-3','解除留言分配')" v-if="roleList['8_2-10-3']">解除分配</Button>
          <Button  class="search_btn template_btn" @click="batchOperation('8_2-10-4','批量删除')" v-if="roleList['8_2-10-4']">批量删除</Button>
          <Button  class="search_btn template_btn" @click="batchOperation('8_2-10-7','批量处理')" v-if="roleList['8_2-10-7']">批量处理</Button>
        </div>
        <div class="fixed_table">
          <el-table :data="infoTableList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  @selection-change="getSelectedId"  @sort-change="sortChange" @cell-click="reportCallScreen" :cell-class-name="returnClassName">
            <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" sortable="custom" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
            <el-table-column  fixed="right" label="操作" width="150" align="center" v-if="roleList['8_2-10-5'] || roleList['8_2-10-6']">
              <template slot-scope="scope">
                <el-button  type="text" size="small" @click="seeMess(scope.row.id,scope.row.leaveName,scope.row.leavePhone,scope.row.leaveCompany,scope.row.leaveEmail,scope.row.leaveContent)" v-show="roleList['8_2-10-5']">处理</el-button>
                <el-button type="text" size="small" @click="deleteMess('统计报表=>明细报表=>会话留言=>删除','8_2-10-6',scope.row.id)" v-if="roleList['8_2-10-6']">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
        </div>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
        <messDistributionPop @closeMessDis="closeMessDis" :showMessDis="showMessDis" :total="total" :checkIds="checkIds" :agentNumber="agentNumber" :leaveName="leaveName" :leavePhone="leavePhone" :leaveChannel="leaveChannel" :leaveContent="leaveContent" :agentNumberAssign="agentNumberAssign" :isCallBack="isCallBack" :starEndTime="starEndTime" :queryParam="queryParam"></messDistributionPop>
        <publicPop @closePublicPop="closePublicPop" :pubTitle="pubTitle" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
        <remarksPop @closeRemarksPop="closeRemarksPop" :showRemarksPop="showRemarksPop" :reIds="reIds" :reName="reName" :rePhone="rePhone" :reCompany="reCompany" :reEmail="reEmail" :reContent="reContent"></remarksPop>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    import messDistributionPop from '@/components/statisticsReportForm/detailedReportForm/MessDistributionPop.vue'
    import publicPop from '@/components/customerMange/PublicPop.vue'
    import remarksPop from '@/components/statisticsReportForm/detailedReportForm/RemarksPop.vue'
    export default {
      name: "ConverMessage",
      mixins:[publicFunClass,customerPublicBtn],
      components:{
        messDistributionPop,
        publicPop,
        remarksPop
      },
      props:{
        pageCode:String
      },
      data(){
        return {
          showPageCount:0,
          total:0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          speedChangePage: 1,
          pageSize:20,
          screenHeight:{height:''},
          tableHeight:600,
          spinShow: false,
          roleList:JSON.parse(localStorage.getItem("roleList")),
          agentNumber:'',
          leaveName:'',
          leavePhone:'',
          leaveChannel:'',
          messageChannelList:[{'id': '-7', 'name': '网页'},{'id': '-8', 'name': '微信公众号'},{'id': '-9', 'name': '小程序'}],
          messageContentList:[],
          messageStatusList:[{'id': '1', 'name': '已分配'},{'id': '0', 'name': '未分配'}],
          messageResultList:[{'id': '1', 'name': '已回访'},{'id': '0', 'name': '未回访'}],
          leaveContent:'',
          agentNumberAssign:'',
          isCallBack:'0',
          starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
          infoTableList:[],
          fieldList: [
          {type: 'selection', width: 50},{width: 150,key:'agentNumber','title':'访客经理'},
          {width: 150,key:'leaveName','title':'访客名称'},{width:150,key:'leavePhone','title':'访客号码'},
          {width:200,key:'leaveContent','title':'留言内容'},
          {width:120,key:'leaveChannel','title':'留言渠道'},{width:150,key:'createTime','title':'留言时间'},
          {width:160,key:'leaveCompany','title':'访客公司'},{width:150,key:'leaveEmail','title':'访客邮箱'},
          {width:150,key:'callRemark','title':'备注'},{width:120,key:'IsCallBack','title':'回访状态'},
          ],
          editable:false,
          menuId:'null',
          journalType:'null',
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          showMessDis:false,
          checkIds:[],
          showPublicPop: false,
          pubTitle:'',
          popSign:'',
          reIds:'',
          reName:'',
          rePhone:'',
          reCompany:'',
          reEmail:'',
          reContent:'',
          showRemarksPop:false,
          orderField:'',
          orderRule:'',
          queryParam: null,
        }
      },
      methods:{
        reset:function(){
          this.agentNumber='';
          this.leaveName='';
          this.leavePhone='';
          this.leaveChannel='';
          this.leaveContent='';
          this.agentNumberAssign='';
          this.isCallBack='0';
          this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        },
        getCustomName:function (name) {
          if(name=="agentNumber"){
            return "agent_number";
          }
          if(name=="leaveName"){
            return "leave_name";
          }
          if(name=="leavePhone"){
            return "leave_phone";
          }
          if(name== "leaveContent" ){
            return "leave_content";
          }
          if(name== "leaveChannel"){
            return "leave_channel";
          }
          if(name=="createTime"){
            return "create_time";
          }
          if(name=="leaveCompany"){
            return "leave_company";
          }
          if(name==  "leaveEmail" ){
            return "leave_email";
          }
          if(name==  "callRemark" ){
            return " call_remark";
          }
          if(name==  "IsCallBack" ){
            return "is_call_back";
          }
          return name;
        },
        sortChange:function(event){
          if(event && event.order){
            this.orderField=this.getCustomName(event.prop);
            this.orderRule=event.order=="descending"?"desc":"asc";
          }else{
            this.orderField="";
            this.orderRule="";
          }
          this.initSearch();
        },
        initSearch:function () {
         this.spinShow=true;
          this.$emit("closeVn",true);
          let that=this;
          let param={
            orderField:this.orderField,
            orderRule:this.orderRule,
            agentNumber:this.agentNumber,
            leaveName:this.leaveName,
            leavePhone:this.leavePhone,
            leaveChannel:this.leaveChannel,//留言渠道
            leaveContent:this.leaveContent,//留言内容
            agentNumberAssign:this.agentNumberAssign,
            isCallBack:this.isCallBack,
            starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            journalType:"null",
            menuId:"null"
          };
          this.queryParam = param;
          this.$http.post("chatLeave/toIndex.json",param) .then(function (res) {
            that.spinShow=false;
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.checkIds=[];
            that.infoTableList=res.data.obj.list.content;
            //that.infoTableList=[{"visitorManager":"刘经理","visitorName":"测试","visitorNumber":"18066790905","messageChannel":"大好中国时代微信公众号","messageTime":"2021-09-08","messageContent":"错错错","messageCompany":"安徽天地万物通信有限公司","messageEmail":"212509871145@qq.com","remarks":"哈哈哈哈哈","visitStatus":"未处理"}];
            that.total=res.data.obj.list.totalSize;
          });
        },
        batchOperation:function(menuId,title) {//导出
          this.journalType='统计报表=>明细报表=>会话留言=>'+title;
          this.menuId=menuId;
          this.popSign=title;
          this.showPublicPop=true;
        },
        distribution:function () {//分配
          this.showMessDis=true;
        },
        closeMessDis:function (flag) {
          this.showMessDis=false;
          if(flag){
              this.initSearch();
          }
        },
        dealLocation:function(name,title)  {//解除分配
          this.journalType='统计报表=>明细报表=>会话留言=>'+title;
          this.menuId=name;
          this.showPublicPop=true;
          this.popSign=title;
        },
        closePublicPop:function (flag,operateStyle,popSign) {
          this.showPublicPop=false;
          let that=this;
          if(popSign=="导出"){
          //导出start
            if(flag){
              let param;
              if (operateStyle=='0'){//选中结果
                if (that.checkIds.length==0){
                  that.$Modal.info({
                    title:'提示',
                    content:"请选择要导出的数据"
                  });
                  return false;
                }
                param={
                ids:this.checkIds.toString(),
                journalType:"统计报表=>明细报表=>会话留言=>按选中结果导出",
                menuId:"8_2-10-1",
                type:operateStyle
                };
              }
              if (operateStyle=='1'){//按搜索结果
                if(that.infoTableList.length==0){
                  that.$Modal.info({
                    title:'提示',
                    content:"当前没有可导出的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再导出"
                  });
                  return false;
                }
                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', operateStyle);
                this.$set(this.queryParam, 'journalType', "统计报表=>明细报表=>会话留言=>按搜索结果导出");
                this.$set(this.queryParam, 'menuId', '8_2-10-1');
                param = this.queryParam;
              }
              that.$Loading.start();
              that.operateExcelExport(param,"chatLeave/exportChatLeave.json");
            }
          //导出end
          }else if(popSign=="批量删除"){//批量start
            if (flag) {
              let param;
              if (operateStyle=='0'){//选中结果删除
                if (that.checkIds.length==0){
                  that.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                param={
                  ids:this.checkIds.toString(),
                  journalType:"统计报表=>明细报表=>会话留言=>按选中结果删除",
                  menuId:"8_2-10-4",
                  type:operateStyle
                };
              }
              if (operateStyle=='1'){//搜索结果删除
                if(that.infoTableList.length==0){
                  that.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再删除"
                  });
                  return false;
                }
                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', operateStyle);
                this.$set(this.queryParam, 'journalType', "统计报表=>明细报表=>会话留言=>按搜索结果删除");
                this.$set(this.queryParam, 'menuId', '8_2-10-4');
                param = this.queryParam;
              }
              that.$Modal.confirm({
                title: '提示',
                content: "是否确定删除",
                onOk: () => {
                  that.$http.post('chatLeave/doDeletes.json',param) .then(function (res) {
                    let result = res.data.flag;
                    if(result!="666"){
                      that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                      });
                      return false;
                    }
                    that.$Message.info(res.data.msg);
                    that.initSearch();
                  });
                }
              });
            }
          }else if(popSign=="解除留言分配"){//解除分配start
              if(flag){
                let that=this;
                let param;
                if (operateStyle=='0'){//选中结果
                  if (that.checkIds.length==0){
                    that.$Modal.info({
                      title:'提示',
                      content:"请选择解除分配的数据"
                    });
                    return false;
                  }
                  param={
                      ids:this.checkIds.toString(),
                      journalType:"统计报表=>明细报表=>会话留言=>按选中结果解除留言分配",
                      menuId:"8_2-10-3",
                      type:operateStyle,
                  };
                }
                if (operateStyle=='1'){//按搜索结果
                  if(that.infoTableList.length==0){
                    that.$Modal.info({
                      title:'提示',
                      content:"当前没有数据"
                    });
                    return false;
                  }

                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再解除分配"
                    });
                    return false;
                  }
                  delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];

                  this.$set(this.queryParam, 'type', operateStyle);
                  this.$set(this.queryParam, 'journalType', "统计报表=>明细报表=>会话留言=>按搜索结果解除留言分配");
                  this.$set(this.queryParam, 'menuId', '8_2-10-3');
                  param = this.queryParam;

                }
                this.$http.post("chatLeave/doUnAssignLeaveMsg.json",param) .then(function (res) {
                      let result=res.data.flag;
                      if(result!="666"){
                        that.$Modal.info({
                          title:'提示',
                          content:res.data.msg
                        });
                        return false;
                      }
                      that.$Message.info(res.data.msg);
                      that.initSearch();
                });
              }
          }else if(popSign=="批量处理"){
              if(flag){
                let that=this;
                let param;
                if (operateStyle=='0'){//选中结果
                  if (that.checkIds.length==0){
                    that.$Modal.info({
                      title:'提示',
                      content:"请选择批量处理的数据"
                    });
                    return false;
                  }
                  param={
                      ids:this.checkIds.toString(),
                      journalType:"统计报表=>明细报表=>会话留言=>按选中结果批量处理",
                      menuId:"8_2-10-7",
                      type:operateStyle,
                      callRemark:"已回访",
                  };
                }
                if (operateStyle=='1'){//按搜索结果
                  if(that.infoTableList.length==0){
                    that.$Modal.info({
                      title:'提示',
                      content:"当前没有数据"
                    });
                    return false;
                  }
                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再批量处理"
                    });
                    return false;
                  }
                  delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];

                  this.$set(this.queryParam, 'type', operateStyle);
                  this.$set(this.queryParam, 'journalType', "统计报表=>明细报表=>会话留言=>按搜索结果批量处理");
                  this.$set(this.queryParam, 'menuId', '8_2-10-7');
                  this.$set(this.queryParam, 'callRemark', '已回访');
                  param = this.queryParam;
                }
                this.$http.post("chatLeave/doDealLeaveMsg.json",param) .then(function (res) {
                      let result=res.data.flag;
                      if(result!="666"){
                        that.$Modal.info({
                          title:'提示',
                          content:res.data.msg
                        });
                        return false;
                      }
                      that.$Message.info(res.data.msg);
                      that.initSearch();
                });
              }
          }
        },
        //处理
        closeRemarksPop:function (flag) {
          this.showRemarksPop=false;
          if(flag){
              this.initSearch();
          }
        },
        seeMess:function(id,name,phone,company,email,content) {
            this.showRemarksPop=true;
            this.reIds=id;
            this.reName=name;
            this.rePhone=phone;
            this.reCompany=company;
            this.reEmail=email;
            this.reContent=content;

        },
        //删除
        deleteMess:function (journalType,menuId,id) {
        let param={
          journalType:journalType,
          menuId:menuId,
          ids:id,
          type:'0'
        };
        let that=this;
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定删除",
          onOk: () => {
            that.$http.post("chatLeave/doDeletes.json",param) .then(function (res) {
              that.spinShow=false;
              let result = res.data.flag;
              if (result != "666") {
                that.$Modal.info({
                  title: '提示',
                  content: res.data.msg
                });
                return false;
              }
              that.$Message.info("删除成功");
              that.initSearch();
            });
          }
        });
      }


      },
     created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-280;
     },
    destroyed(){
      this.$emit("closeVn",true);
    },
     watch:{
       pageCode:function () {
         if(this.pageCode=='8_2-10' && this.showPageCount==0){
          this.$emit("openVn", true);
          this.showPageCount++;
        }
       }
     }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/ConverMessage.vue